import React from 'react';

import styles from './BackgroundImage.module.scss';

const BackgroundImage = ({ image, children, className, light }) => {
  const imageUrl =
    typeof image === 'string' || image instanceof String
      ? image
      : image.childImageSharp.fluid.src;

  const backgroundImages = [
    `url(${imageUrl})`,
    light
      ? `linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))`
      : `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))`
  ].reverse();

  return (
    <section
      className={`${styles.wrapper} ${className}`}
      style={{
        backgroundImage: backgroundImages
      }}
    >
      {children}
    </section>
  );
};

export default BackgroundImage;
